const sharedStops = ["Nonneseter", "Bergen busstasjon", "Kronstad"]

export default sharedStops